/**
 * Static data for HomePage sections.
 */
import {
  Briefcase, Users, Building2, GraduationCap, Plane, Globe,
  HardHat, Fuel, Heart, Ship, Wrench, Utensils,
  Shield, Award, CheckCircle,
} from 'lucide-react';

export const countries = [
  { name: 'Canada', flag: '🇨🇦', path: '/countries/canada' },
  { name: 'Australia', flag: '🇦🇺', path: '/countries/australia' },
  { name: 'Saudi Arabia', flag: '🇸🇦', path: '/saudi-arabia' },
  { name: 'UAE', flag: '🇦🇪', path: '/skilled/uae/uae-golden-visa' },
  { name: 'Germany', flag: '🇩🇪', path: '/germany-opportunity-card' },
  { name: 'UK', flag: '🇬🇧', path: '/skilled/uk/uk-skilled-worker-visa' },
  { name: 'USA', flag: '🇺🇸', path: '/business/usa/eb-5-visa' },
  { name: 'Qatar', flag: '🇶🇦', path: '/contact' },
];

export const services = [
  { icon: Globe, title: 'International Manpower Recruitment', description: 'Government-approved overseas recruitment for Saudi Arabia, Europe, Russia & Israel — MEA-registered.', path: '/international-manpower-recruitment-europe-russia-israel-saudi-arabia' },
  { icon: Briefcase, title: 'Employment Visas', description: 'Work permits & employment authorization for Gulf, Middle East & Europe' },
  { icon: Users, title: 'Skilled Migration', description: 'PR pathways for Canada, Australia, New Zealand & UK' },
  { icon: Building2, title: 'Business & Investor', description: 'EB-5, Golden Visa & entrepreneur immigration programs' },
  { icon: GraduationCap, title: 'Study to Work', description: 'International education with post-study work rights' },
  { icon: Plane, title: 'Visa Stamping', description: 'Embassy liaison & document processing services' },
];

export const industries = [
  { icon: HardHat, name: 'Construction', desc: 'Building the future' },
  { icon: Fuel, name: 'Oil & Gas', desc: 'Energy sector expertise' },
  { icon: Heart, name: 'Healthcare', desc: 'Medical professionals' },
  { icon: Ship, name: 'Shipping', desc: 'Maritime & logistics' },
  { icon: Wrench, name: 'Engineering', desc: 'Technical excellence' },
  { icon: Utensils, name: 'Hospitality', desc: 'Service industry' },
];

export const whyZafco = [
  { title: 'Government Approved', desc: 'MEA RC: B-0762/DEL/PER/1000+/5/9148/2015', icon: Shield },
  { title: 'Embassy Empanelled', desc: 'Direct partnership with Royal Saudi Embassy', icon: Award },
  { title: 'Transparent Process', desc: 'No hidden fees, clear timelines', icon: CheckCircle },
  { title: 'End-to-End Support', desc: 'From application to landing', icon: Globe },
];

export const trustCountries = [
  { flag: '🇸🇦', name: 'Saudi Arabia', href: '/saudi-arabia' },
  { flag: '🇦🇪', name: 'UAE',          href: '/skilled/uae/uae-golden-visa' },
  { flag: '🇶🇦', name: 'Qatar',        href: '/contact?country=Qatar' },
  { flag: '🇨🇦', name: 'Canada',       href: '/countries/canada' },
  { flag: '🇬🇧', name: 'UK',           href: '/skilled/uk/uk-skilled-worker-visa' },
  { flag: '🇦🇺', name: 'Australia',    href: '/countries/australia' },
  { flag: '🇩🇪', name: 'Germany',      href: '/germany-opportunity-card' },
];

export const gulfCountries = [
  { flag: '🇸🇦', name: 'Saudi Arabia', tag: 'Embassy Empanelled', href: '/saudi-arabia', primary: true },
  { flag: '🇦🇪', name: 'UAE',          tag: 'Golden Visa & Jobs', href: '/skilled/uae/uae-golden-visa' },
  { flag: '🇶🇦', name: 'Qatar',        tag: 'Skilled Workers',    href: '/contact?country=Qatar' },
  { flag: '🇰🇼', name: 'Kuwait',       tag: 'Manpower Supply',    href: '/contact?country=Kuwait' },
  { flag: '🇴🇲', name: 'Oman',         tag: 'Bulk Recruitment',   href: '/contact?country=Oman' },
  { flag: '🇧🇭', name: 'Bahrain',      tag: 'Direct Placement',   href: '/contact?country=Bahrain' },
];

export const popularGuides = [
  { flag: '🇨🇦', title: 'Canada Express Entry Guide', desc: 'Complete CRS calculator, eligibility criteria, and step-by-step application process.', to: '/cms/canada-express-entry' },
  { flag: '🇦🇺', title: 'Australia PR Visa Guide',    desc: 'Subclass 189, 190, 491 visas explained with points calculator and state nominations.', to: '/countries/australia' },
  { flag: '🇬🇧', title: 'UK Skilled Worker Visa',      desc: 'Points-based system explained with salary thresholds and settlement pathway.',         to: '/cms/uk-skilled-worker-visa' },
  { flag: '🇩🇪', title: 'Germany Opportunity Card',    desc: 'New points-based Chancenkarte visa for skilled workers seeking jobs in Germany.',     to: '/cms/germany-opportunity-card' },
  { flag: '🇦🇪', title: 'UAE Golden Visa Guide',       desc: '10-year residency visa for investors, entrepreneurs, and skilled professionals.',     to: '/skilled/uae/uae-golden-visa' },
  { flag: '🇺🇸', title: 'USA Green Card Guide',        desc: 'EB-1, EB-2, EB-3, EB-5 pathways to US permanent residency explained.',                to: '/cms/usa-green-card' },
];
